import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        operable: filters.operable,
        date:     Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'CMDBMonitoringCake',
        endpoint:           endpoints.cmdb.monitoringCake,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            total:   response.with_monitoring + response.without_monitoring,
            results: [
                {
                    name: 'withMonitoring',
                    y:    response.with_monitoring
                },
                {
                    name: 'withoutMonitoring',
                    y:    response.without_monitoring
                }
            ]
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBMonitoringCake.js